import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { Route, RouterModule } from '@angular/router';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateFRParserFormatter } from 'src/app/components/terminal-runs/ngb-date-custom-parser';
import { TerminalRunDetailsComponent } from 'src/app/components/terminal-runs/terminal-run-details/terminal-run-details.component';
import { TimePickerModule } from 'src/app/components/time-picker/time-picker.module';
import { CvvCommonModule } from '../cvv-common/cvv-common.module';
import { SharedModule } from '../shared-module/shared.module';
import { TerminalRunsComponent } from './../../components/terminal-runs/terminal-runs.component';


const routes: Route[] = [
  {
    path: 'terminalRuns',
    component: TerminalRunsComponent,
    children: [ { path: 'create', component: TerminalRunsComponent, outlet: 'side' } ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatExpansionModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatOptionModule,
    MatIconModule,
    MatDialogModule,
    NgbDatepickerModule,
    NgbModule,
    MatButtonToggleModule,
    SharedModule,
    TimePickerModule,
    MatMenuModule,
    CvvCommonModule
  ],
  declarations: [ TerminalRunsComponent, TerminalRunDetailsComponent ],
  exports: [ TerminalRunsComponent, TerminalRunDetailsComponent ],
  providers: [ { provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter } ]
})
export class TerminalRunsModule {}
